import { Navigate, useLocation } from "react-router-dom";

import { createRerouteRegex } from "App/routes/pageNames";
import { AppPagePaths, LegacyPagePaths } from "App/routes/paths";
import { convoIntelPathResources } from "Pages/convoIntel/convoIntelPaths";
import { initLooker } from "Services/Looker/LookerService";

initLooker();

export function TranscriptsRerouter(): JSX.Element {
    const location = useLocation();
    const pathAfterTranscripts = location.pathname.replace(createRerouteRegex(LegacyPagePaths.transcripts), "");

    let newPath: string;

    // Map specific paths
    if (pathAfterTranscripts === "") {
        newPath = `${AppPagePaths.convoIntel}/${convoIntelPathResources.recordings}`;
    } else if (
        pathAfterTranscripts === convoIntelPathResources.trackers ||
        pathAfterTranscripts.startsWith(`${convoIntelPathResources.trackers}/`)
    ) {
        // Handle trackers or trackers/... -> moments or moments/...
        const pathAfterTrackers = pathAfterTranscripts.substring(convoIntelPathResources.trackers.length);
        newPath = `${AppPagePaths.convoIntel}/${convoIntelPathResources.moments}${pathAfterTrackers}`;
    } else {
        // For scorecards, insights, custom-analysis, and edit paths
        newPath = `${AppPagePaths.convoIntel}/${pathAfterTranscripts}`;
    }

    // Preserve query params and hash fragments
    newPath += `${location.search}${location.hash}`;

    return <Navigate to={newPath} replace />;
}
